import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import { Index } from "./pages/Index.tsx";
import { ModernizationReport } from "./pages/ModernizationReport";
import { SiteForwardBadge } from "./components/ui/SiteForwardBadge.tsx";
import "./index.css";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/modernization-report" element={<ModernizationReport />} />
          </Routes>
          <SiteForwardBadge />
        </Layout>
      </Router>
    </HelmetProvider>
  );
}

export default App;
